import $ from "jquery";

$(".search-btn").click(

    function () {

        $(this).siblings("form").toggleClass('active');
        $(".navbar-nav").toggleClass("search-open");

        $(this).siblings("form").find(".form-control").select();
        $(this).siblings("form").find(".form-control ").focus();

        $(this).find("i").toggleClass("bi-search");
        $(this).find("i").toggleClass("bi-x-lg");
    }
);

$(".language-picker").click(

    function () {
        $(this).toggleClass("active");
    }
);


$("#hamburger-menu-button").click(function () {
    $("#hamburger-menu-button").toggleClass("hamburger-menu-change");
});

